"use client";

import { useModuleAccess } from "@/lib/useModuleAccess";

/**
 * True when tenant has an active Prism subscription.
 * Statsig preview + staging hostnames are legacy internal QA paths only.
 */
export function usePrismAccess(): { ready: boolean; enabled: boolean } {
    const { hasAccess, loaded } = useModuleAccess();
    const entitled = hasAccess("prism");
    return {
        ready: loaded,
        enabled: entitled,
    };
}
